import React from "react";
import * as styles from "./PrintandShare.module.css";
import { ComponentWidth, ComponentProps } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";

interface Props extends ComponentProps, ComponentWidth {
  pageTitle: string;
  pageUrl: string;
}

export const PrintandShare: React.FC<Props> = ({
  pageTitle,
  pageUrl,
  width,
  ...props
}) => {
  const classes = [styles.container];
  width === "contained" && classes.push(styles.contained);

  const handlePrintClick = (event: React.MouseEvent) => {
    window.print();
  };

  const handleShareClick = (event: React.MouseEvent) => {
    window.location.href = `mailto:?subject=${pageTitle}&body=${pageUrl}`;
  };

  return (
    <SectionWrapper {...props}>
      <div className={classes.join(" ")}>
        <div className={styles.printandshare}>
          <button
            aria-label="Print Article"
            onClick={handlePrintClick}
            className={styles.printBtn}
          >
            <img src="/icons/print.svg" alt="Printer Icon" />
          </button>
          <button aria-label="Share Article" onClick={handleShareClick}>
            <img src="/icons/share.svg" alt="Share Icon" />
          </button>
        </div>
      </div>
    </SectionWrapper>
  );
};
